import { ListStore } from '@softline/core';
import { Application } from './data/application';

export const ApplicationStore = ListStore.create<Application>();
